/**
 * Where the access token lives.
 *
 * "Remember me" is the difference between the two web storages, not a flag we
 * invent: checked writes to localStorage and the session survives closing the
 * browser; unchecked writes to sessionStorage and it does not. Reads check
 * sessionStorage first so a deliberate session-only sign-in is never shadowed
 * by a stale persistent token left behind by an earlier one.
 *
 * Every accessor is wrapped: Safari in private mode throws on write, and a
 * blocked-storage error must log the user out cleanly rather than crash the
 * app on boot.
 */
const KEY = 'access_token';

const safe = (fn, fallback = null) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

export function getToken() {
  return safe(() => sessionStorage.getItem(KEY)) || safe(() => localStorage.getItem(KEY));
}

export function setToken(token, { remember = true } = {}) {
  // Clear both first, so switching "remember me" between sign-ins cannot
  // leave the old copy behind in the other storage.
  clearToken();
  safe(() => (remember ? localStorage : sessionStorage).setItem(KEY, token));
}

export function clearToken() {
  safe(() => localStorage.removeItem(KEY));
  safe(() => sessionStorage.removeItem(KEY));
}
